import React from 'react';
import { curatedModels } from '../data/models';
import { formatReleased } from '../utils/format';
import { PageHeader } from '../components/PageHeader';
import { SourceRef } from '../components/SourceRef';
import { DataBadge } from '../components/DataBadge';
import { COMPILED_LABEL } from '../data/sources';
import { CuratedModelTable } from '../components/models/CuratedModelTable';
import { HFLiveTable } from '../components/models/HFLiveTable';
export function Models() {
  const total = curatedModels.length;
  const openShare = curatedModels.filter(m => m.license !== 'proprietary').length / total * 100;
  const newest = curatedModels.reduce<string | null>((acc, m) => m.released && (!acc || m.released > acc) ? m.released : acc, null);
  return <>
      <PageHeader title="Models" lede="The minds behind the machine population. A hand-maintained table of the most significant models — every row linked to its official announcement — with a live layer from Hugging Face beneath." data-id="element-740" data-mp="1fy5f4jeonbsw">
        <DataBadge mode="snapshot" source="Curated model table" asOf={COMPILED_LABEL} data-id="element-741" data-mp="2l2h1iieyhv6s" />
      </PageHeader>

      <section className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-742" data-mp="2q0igos99hacz">
        <dl className="grid grid-cols-3 border-b border-line" data-id="element-743" data-mp="2bcxgb63rtp8r">
          <div className="py-5 pr-4" data-id="element-744" data-mp="2bab7l35593oy">
            <dt className="text-[12.5px] text-muted" data-id="element-745" data-mp="2gagygh3lam5z">Models listed</dt>
            <dd className="mt-1 font-mono text-2xl tabular text-ink" data-id="element-746" data-mp="22bqxgqdng2cc">
              {total}
              <SourceRef id="censusCurated" data-id="element-747" data-mp="27ake2ro8g9gq" />
            </dd>
          </div>
          <div className="border-l border-line py-5 pl-4 md:pl-6" data-id="element-748" data-mp="278hbl85w8nv4">
            <dt className="text-[12.5px] text-muted" data-id="element-749" data-mp="1sel6rj8y6dcn">Open-weight share</dt>
            <dd className="mt-1 font-mono text-2xl tabular text-ink" data-id="element-750" data-mp="1xbuw6ywc6p0h">
              {openShare.toFixed(0)}%
              <SourceRef id="censusCurated" data-id="element-751" data-mp="3mr2l21bt6355" />
            </dd>
          </div>
          <div className="border-l border-line py-5 pl-4 md:pl-6" data-id="element-752" data-mp="3rq5hixdq311i">
            <dt className="text-[12.5px] text-muted" data-id="element-753" data-mp="3rob6cas96nam">Newest release</dt>
            <dd className="mt-1 font-mono text-2xl tabular text-ink" data-id="element-754" data-mp="3qa1js4lkun90">
              {formatReleased(newest)}
              <SourceRef id="censusCurated" data-id="element-755" data-mp="3l8kkgdiqr8uj" />
            </dd>
          </div>
        </dl>

        <aside className="mt-6 border-l-2 border-machine bg-machine/[0.05] px-4 py-3 text-[13.5px] text-ink/90" data-id="element-756" data-mp="3gbkmyqzyjef1">
          Frontier labs no longer disclose parameter counts — fields show “undisclosed” with source, not guesses.
        </aside>

        <div id="curated" className="mt-8" data-id="element-757" data-mp="7v8zollc86bt">
          <CuratedModelTable data-id="element-758" data-mp="7wk3umip3g3g" />
        </div>

        <div className="mt-16" data-id="element-759" data-mp="7xli0zv0cipe">
          <HFLiveTable data-id="element-760" data-mp="33qzw0v1wbsf" />
        </div>
      </section>
    </>;
}